import { TweenLite, Power2 } from 'gsap'

import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'
import SizesMixin from '@/mixins/Sizes.js'

import AppWordsFade from '@/components/app-words-fade'

export default
{
    name: 'app-page-chapters',

    mixins:
    [
        EventHubMixin,
        APIMixin,
        SizesMixin
    ],

    components:
    {
        AppWordsFade
    },

    data()
    {
        return {
            chapters: null,
            chaptersShowIndex: 0,
            chaptersAnimatedLetters: false,
            chaptersLetterIndex: 0,
            content: null
        }
    },

    created()
    {
        this.chaptersAnimatedLetters = !this.$root.config.platform.touch
        // this.chaptersAnimatedLetters = false

        // Title
        document.title = this.$root.config.title

        this.fetch('chapters', { per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || !(data instanceof Array))
            {
                this.$router.push({ name: '404' })
                return
            }

            const chapters = []
            for(const _chapter of data)
            {
                const chapter = {}

                chapter.id = _chapter.id
                chapter.slug = _chapter.acf.slug
                chapter.title = _chapter.acf.title

                chapters.unshift(chapter)
            }

            this.chapters = chapters

            if(this.content)
            {
                this.$nextTick(() =>
                {
                    this.setChapters()

                    // Stroke bounding
                    this.stroke.bounding = this.stroke.$cta.getBoundingClientRect()
                })
            }
        })

        this.fetch('pages', { slug: 'home,menu,general', per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || data.length < 1)
            {
                this.$router.push({ name: '404' })
                return
            }

            this.content = { acf: { ...data[1].acf, ...data[2].acf, main_video_url: data[0].acf.main_video_url } }

            // SEO
            document.title = this.content.acf.seo_title ? this.content.acf.seo_title : this.content.acf.title.replace(/<br ?\/?>/gi, '')
            if(this.content.acf.seo_description)
            {
                document.querySelector('meta[name=description]').content = this.content.acf.seo_description
            }

            // Papillon
            this.$nextTick(() =>
            {
                window.dispatchEvent(new Event('papillon'))
            })

            this.$nextTick(() =>
            {
                // Header logo
                this.$eventHub.$emit('headerLogo.setState', { state: 'back', backText: this.content.acf.label_back_home, backTo: { name: `${this.$route.meta.lang}_home` } })
            })

            if(this.chapters)
            {
                this.$nextTick(() =>
                {
                    this.setChapters()

                    // Stroke bounding
                    this.stroke.bounding = this.stroke.$cta.getBoundingClientRect()
                })
            }
        }, this.$root.isFirstPage())
    },

    mounted()
    {
        // Stroke
        this.stroke = {}
        this.stroke.$cta = this.$refs.cta.$el
        this.stroke.x = - 20
        this.stroke.length = 20
        this.stroke.lineWidth = 1
        this.stroke.strokeStyle = '#3092d0'
        this.stroke.bounding = this.stroke.$cta.getBoundingClientRect()

        this.stroke.mouseenter = () =>
        {
            if(!this.destroyed)
            {
                TweenLite.to(this.stroke, 0.5, { length: this.stroke.bounding.width - 60 - 10, ease: Power2.easeOut })
            }
        }

        this.stroke.mouseleave = () =>
        {
            if(!this.destroyed)
            {
                TweenLite.to(this.stroke, 0.5, { length: 20, ease: Power2.easeOut })
            }
        }

        if(!this.$root.config.platform.touch)
        {
            this.stroke.$cta.addEventListener('mouseenter', this.stroke.mouseenter)
            this.stroke.$cta.addEventListener('mouseleave', this.stroke.mouseleave)
        }

        window.setTimeout(() =>
        {
            if(!this.destroyed)
            {
                TweenLite.to(this.stroke, 1, { x: this.stroke.bounding.left + 30, ease: Power2.easeOut })
            }
        }, 500)

        this.$eventHub.$emit('line.createStroke', this.stroke)

        // Mark
        this.$eventHub.$emit('line.setElement', this.$refs.lineMark)

        this.$eventHub.$on('player.onActivate', this.onPlayerActivate)
        this.$eventHub.$on('player.onDeactivate', this.onPlayerDeactivate)
    },

    beforeDestroy()
    {
        this.destroyed = true

        if(!this.$root.config.platform.touch)
        {
            this.stroke.$cta.removeEventListener('mouseenter', this.stroke.mouseenter)
            this.stroke.$cta.removeEventListener('mouseleave', this.stroke.mouseleave)
        }

        let $eventHub = this.$eventHub
        let stroke = this.stroke

        TweenLite.to(this.stroke, 1, { x: this.sizes.width, length: 30, ease: Power2.easeInOut, onComplete()
        {
            $eventHub.$emit('line.deleteStroke', stroke)
            $eventHub = null
            stroke = null
        } })
    },

    methods:
    {
        onPlayerActivate()
        {
            TweenLite.to(this.stroke, 1, { x: this.sizes.width, length: 0, ease: Power2.easeInOut })
        },

        onPlayerDeactivate()
        {
            this.stroke.x = 0
            this.stroke.length = 0

            TweenLite.to(this.stroke, 0.3, { x: this.stroke.bounding.left + 30, length: 20, ease: Power2.easeOut })

            this.$eventHub.$emit('line.setElement', this.$refs.lineMark, true)
        },

        setChapters()
        {
            this.$eventHub.$emit('line.moveToElement')

            this.chaptersElements = []

            const $chapters = [...this.$refs.chapters, this.$refs.about]

            if(!$chapters)
            {
                return
            }

            if(!this.$root.config.platform.touch)
            {
                this.$refs.chaptersContainer.addEventListener('mouseleave', () =>
                {
                    if(!this.destroyed)
                    {
                        TweenLite.to(this.stroke, 0.3, { x: this.stroke.bounding.left + 30, length: 20, ease: Power2.easeOut })
                        this.$eventHub.$emit('line.moveToElement')
                    }
                })
            }

            for(const $chapter of $chapters)
            {
                const chapter = {}
                chapter.$el = $chapter.$el
                chapter.boundings = chapter.$el.getBoundingClientRect()

                if(!this.$root.config.platform.touch)
                {
                    chapter.$el.addEventListener('mouseenter', () =>
                    {
                        if(!this.destroyed)
                        {
                            TweenLite.to(this.stroke, 0.3, { x: this.stroke.bounding.left - 80, length: 0, ease: Power2.easeOut })
                            this.$eventHub.$emit('line.moveTo', chapter.boundings.top + chapter.boundings.height * 0.5)
                        }
                    })
                }

                this.chaptersElements.push(chapter)
            }

            // Show timeout
            const showChapter = () =>
            {
                this.chaptersShowIndex++

                if(this.chaptersShowIndex <= this.chaptersElements.length + 1)
                {
                    window.setTimeout(showChapter, 300)
                }
            }

            showChapter()
        },

        onResize()
        {
            this.stroke.bounding = this.stroke.$cta.getBoundingClientRect()
            this.lineMarkY = this.$refs.lineMark.offsetTop + 30

            if(this.chaptersElements)
            {
                // Update chapters boundings
                for(const chapter of this.chaptersElements)
                {
                    chapter.boundings = chapter.$el.getBoundingClientRect()
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-chapters/script.js